import { STRING_MAP } from "../../types";
// tslint:disable:no-bitwise
export class ExtensionHelper {

    // URL safe base64 encoding
    // reference: https://gist.github.com/jhurliman/1250118
    public static Base64Encode(id: string): string {
        return ExtensionHelper.btoa_se(id)
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
    }

    // URL safe base64 decoding
    // reference: https://gist.github.com/jhurliman/1250118
    public static Base64Decode(encodedId: string): string {

        encodedId = encodedId.replace(/-/g, "+")
            .replace(/_/g, "/");

        while (encodedId.length % 4) {
            encodedId += "=";
        }

        return ExtensionHelper.atob_se(encodedId);
    }

    // self implemented btoa to work both for client and server without importing module
    public static btoa_se(str) {
        let buffer;

        if (str instanceof Buffer) {
            buffer = str;
        } else {
            // change "new Buffer(string, encoding)" to "Buffer.from(string, encoding)"
            // see https://stackoverflow.com/questions/52165333/deprecationwarning-buffer-is-deprecated-due-to-security-and-usability-issues
            buffer = Buffer.from(str.toString(), "binary");
        }

        return buffer.toString("base64");
    }

    public static atob_se(str) {
        // change "new Buffer(string, encoding)" to "Buffer.from(string, encoding)"
        // see https://stackoverflow.com/questions/52165333/deprecationwarning-buffer-is-deprecated-due-to-security-and-usability-issues
        return Buffer.from(str, "base64").toString("binary");
    }


    public static hashCode(id: string) {
        if (Array.prototype.reduce) {
            return id.split("").reduce(function (a, b) {
                a = ((a << 5) - a) + b.charCodeAt(0);
                return a & a;
            }, 0);
        }
        let hash = 0;
        if (id.length === 0) {
            return hash;
        }
        for (let i = 0; i < id.length; i++) {
            const character = id.charCodeAt(i);
            hash = ((hash << 5) - hash) + character;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }


    public static strMapToObj<P>(strMap: STRING_MAP<P>): any {
        const obj = Object.create(null);
        for (const [k, v] of <any>strMap) {
            // We don’t escape the key '__proto__'
            // which can cause problems on older engines
            obj[k] = v;
        }
        return obj;
    }

    public static objToStrMap<P>(obj): STRING_MAP<P> {
        const strMap = new Map<string, P>();
        for (const k of Object.keys(obj)) {
            strMap.set(k, obj[k]);
        }
        return strMap;
    }


    public static strMapToJson<P>(strMap: STRING_MAP<P>): string {
        return JSON.stringify(ExtensionHelper.strMapToObj<P>(strMap));
    }

    public static jsonStrToStrMap<P>(jsonStr: string): STRING_MAP<P> {
        return ExtensionHelper.objToStrMap<P>(JSON.parse(jsonStr));
    }

    public static jsonToStrMap<P>(jsonStr: any): STRING_MAP<P> {
        return ExtensionHelper.objToStrMap<P>(jsonStr);
    }

    public static jsonToSchema(json: any[]): any {
        const schema = <any>{};
        schema.type = "object";
        schema.properties = <any>{};
        if (json.length > 0) {
            // schema.properties.type = "object";
            // schema.properties.properties = <any>{};
            schema.required = [];
            for (let i = 0; i < json.length; i++) {
                const params = <any>{};
                if (json[i].required === true || json[i].required === "true") {
                    schema.required.push(json[i].parameterName);
                }
                // params.required = json[i].required;
                if (json[i].repeating === "true") {
                    params.type = "array";
                    params.items = <any>{};
                    params.items.type = json[i].type;
                } else {
                    params.type = json[i].type;
                }
                schema.properties[json[i].parameterName] = params;
            }
        }
        return JSON.stringify(schema);
    }

    public static extractJsonFromPath(path: string): string {
        if (path) {
            const splitPath = path.split("{"), pathParams = [];
            for (let i = 1; i < splitPath.length; i++) {
                if (splitPath[i].indexOf("}") > -1) {
                    const pathParam = splitPath[i].split("}")[0];
                    pathParams.push({
                        parameterName: pathParam,
                        type: "string"
                    });
                }
            }
            if (pathParams.length > 0) {
                return JSON.stringify(pathParams);
            } else {
                return "";
            }
        } else {
            return "";
        }
    }

    public static validateSchema(value: string) {
        const response = {
            error: false,
            msg: null
        };
        if (value && value.length > 0) {
            let valRes = void 0;
            try {
                valRes = JSON.parse(value);
                valRes = JSON.stringify(valRes);
            } catch (e) {
                response.error = true;
                response.msg = "Unexpected string in JSON";
            }
        }
        return response;
    }

    public static validateInt(value) {
        let x;
        if (isNaN(value)) {
            return false;
        }
        x = parseFloat(value);
        // tslint:disable-next-line:no-bitwise
        return (x | 0) === x;
    }
}
